export default __webpack_public_path__ + "static/media/Sharing Guidelines.8a0a475e.svg";